"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAnswerArgsSchema = exports.createAnswerFromArgs = exports.createAnswerArgsValidator = exports.createAnswerArgsSchema = exports.MAX_ANSWER_BODY_LENGTH = void 0;
var channel_1 = require("../channel");
var suretype_1 = require("suretype");
var common_1 = require("../../../common");
// --------------------------
// constants
// --------------------------
exports.MAX_ANSWER_BODY_LENGTH = 4000;
// --------------------------
// create
// --------------------------
exports.createAnswerArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("createAnswer").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    answerId: common_1.idSchema.required(),
    issueId: common_1.idSchema.required(),
    body: suretype_1.v.string().maxLength(exports.MAX_ANSWER_BODY_LENGTH).required(),
    anonymous: suretype_1.v.boolean().required(),
    global: suretype_1.v.boolean().required()
});
exports.createAnswerArgsValidator = (0, suretype_1.compile)(exports.createAnswerArgsSchema);
function createAnswerFromArgs(user, args) {
    return {
        authorId: user.id,
        details: __assign(__assign(__assign({}, (!args.anonymous && user.name) && {
            authorName: user.name
        }), (args.global) && {
            communityId: args.channel.communityId
        }), { body: args.body, 
            // commitId: args.answerId,
            // contributors: [],
            counters: {
                comments: 0,
                proposals: 0
            } }),
        // sort
        createdOn: (new Date()).getTime(),
        counters: {
            upVotes: 0
        }
    };
}
exports.createAnswerFromArgs = createAnswerFromArgs;
// --------------------------
// update
// --------------------------
exports.updateAnswerArgsSchema = suretype_1.v.object({
    collection: suretype_1.v.string().const("answers").required(),
    update: suretype_1.v.object({
        body: suretype_1.v.string().maxLength(exports.MAX_ANSWER_BODY_LENGTH).required()
    }).required()
});
